import styled from 'styled-components';

import { spacing } from '../../../../atoms/spacing';
import { font } from '../../../../atoms/typography';
import { color } from '../../../../atoms/colors';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${spacing[32]};
  gap: ${spacing[12]};
  border-radius: ${spacing[12]};
  background: linear-gradient(
      141deg,
      rgba(199, 220, 252, 0.2) 27.87%,
      rgba(255, 255, 255, 0) 87.35%
    ),
    #f2f6fc;
  box-shadow: 0px 4px 6px -2px rgba(16, 24, 40, 0.03),
    0px 12px 16px -4px rgba(16, 24, 40, 0.08);

  .heading {
    ${font('display', 'xs', '500')}
    color: ${color.darkBlue[1000]};
  }
`;

export const Info = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[12]};

  .email,
  .phone {
    display: flex;
    align-items: center;
    gap: ${spacing[12]};
    ${font('text', 'lg', '400')}
    color: ${color.darkBlue[600]};
  }
`;

export const Circle = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${color.blue[700]};
  color: ${color.white};
`;
